import { FaUser, FaMapMarkerAlt, FaClock, FaTruck } from "react-icons/fa";
import React, { useContext, useState, useEffect } from "react";
import "./ProductDisplay.css";
import star_icon from "../Assets/star_icon.png";
import star_dull_icon from "../Assets/star_dull_icon.png";
import logo from "../Assets/logo-04.png";
import quality_icon from "../Assets/quality.png";
import money_icon from "../Assets/save-money.png";
import trust_icon from "../Assets/trust.png";
import { ShopContext } from "../../Context/ShopContext";
import { backend_url, currency } from "../../App";
import About from "../About/About";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import OrderPopup from "../OrderPopUp/OrderPopUp";
import { useNavigate } from "react-router-dom";
import EstimatorModal from "./EstimatorModal";
import EstimatorImage1 from "../Assets/est-1.jpeg"
import EstimatorImage2 from "../Assets/est-2.jpeg"

const Products = ({ product }) => {
  const iconMap = {
    FaUser: <FaUser className="text-green-700 text-lg" />,
    FaMapMarkerAlt: <FaMapMarkerAlt className="text-green-700 text-lg" />,
    FaClock: <FaClock className="text-green-700 text-lg" />,
    FaTruck: <FaTruck className="text-green-700 text-lg" />,
  };

  const navigate = useNavigate();

  const isAuthorize = !!localStorage.getItem("auth-token");

  const [count, setCount] = useState(1);

  const [activeTab, setActiveTab] = useState("Description");

  const { addToCart, cartItems, deleteFromCart } = useContext(ShopContext);

  const [selectedImage, setSelectedImage] = useState(product?.images?.[0]);

  const [zoomStyle, setZoomStyle] = useState({});

  // const [quantity, setQuantity] = useState(1);

  const [selectedSize, setSelectedSize] = useState("");

  const [showPopup, setShowPopup] = useState(false);

  const [userDetails, setUserDetails] = useState({});

  const [openModal, setOpenModal] = useState(false);

  useEffect(() => {
    const fetchUserDetails = async () => {
      try {
        const token = localStorage.getItem("auth-token");
        if (!token) return;

        const response = await fetch(`${backend_url}/getuserdetails`, {
          method: "GET",
          headers: {
            "auth-token": token,
          },
        });

        const data = await response.json();

        if (data.success) {
          setUserDetails(data.user); // Combined data
        } else {
          console.error("Failed to fetch user details:", data.message);
        }
      } catch (error) {
        console.error("Error fetching user details:", error);
      }
    };

    fetchUserDetails();
  }, []);

  // const handleSizeSelect = (size) => {
  //   setSelectedSize(size);
  // };

  const handlePopupNow = () => {
    // if (!selectedSize) {
    //   toast.error("Please select a size before ordering!");
    //   return;
    // }

    if (!isAuthorize) {
      toast.info("Please Login/Register to continue with your order");
      setTimeout(() => {
        navigate("/login");
      }, 5500);
      return;
    }
  
    setShowPopup(true);
  };

  const handleInputChange = (e) => {
    const value = parseFloat(e.target.value);
    if (!isNaN(value) && value >= 0.5) {
      setCount(value);
    }
  };

  // Close popup
  const closePopup = () => setShowPopup(false);

  const handleMouseMove = (e) => {
    const { left, top, width, height } = e.target.getBoundingClientRect();
    const x = ((e.clientX - left) / width) * 100;
    const y = ((e.clientY - top) / height) * 100;

    setZoomStyle({
      transformOrigin: `${x}% ${y}%`,
      transform: "scale(2)",
      transition: "transform 0.1s ease",
    });
  };

  const handleMouseLeave = () => {
    setZoomStyle({
      transform: "scale(1)",
    });
  };

  const discountPercentage = product.new_price; // Discount percentage from API

  const newPrice = product.old_price
    ? (product.old_price * (100 - discountPercentage)) / 100
    : product.new_price;

  return (
    <>
      {/* <div className="bg-white"> */}
      <div className="bg-white px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 max-w-7xl mx-auto gap-10">
          {/* Left Section */}
          <div>
            {/* Main Image */}
            <div className="productdisplay-container">
              <img
                crossOrigin="anonymous"
                src={selectedImage || product.images[0]}
                alt="Selected Product"
                className="productdisplay-main-img w-full h-[300px] sm:h-[400px] object-cover rounded-md"
                onMouseMove={handleMouseMove}
                onMouseLeave={handleMouseLeave}
                style={zoomStyle}
                loading="lazy"
              />
            </div>

            {/* Thumbnails */}
            <div className="grid grid-cols-4 gap-2 mt-3 w-full">
              {product.images.slice(0, 4).map((item, i) => (
                <img
                  crossOrigin="anonymous"
                  key={i}
                  src={item}
                  alt="Thumbnail"
                  onClick={() => setSelectedImage(item)}
                  className={`cursor-pointer object-cover rounded-md ${
                    selectedImage === item
                      ? "ring-2 ring-[#b6abfa]"
                      : "ring-1 ring-transparent"
                  } transition-transform hover:scale-105`}
                  style={{
                    height: "100px",
                    width: "100%",
                  }}
                />
              ))}
            </div>
          </div>

          {/* Right Section */}
          <div className="flex flex-col gap-5">
            {/* Product Info */}
            <p className="text-sm flex gap-2 flex-wrap items-center">
              Design ID: {product.unique_id}
              {product.status && (
                <span
                  className={`text-xs text-white px-2 py-1 rounded-md font-semibold ${
                    product.status.toLowerCase() === "in-stock"
                      ? "bg-[#a565e9]"
                      : "bg-[#e96565]"
                  }`}
                >
                  {product.status}
                </span>
              )}
              {product.bestseller?.toLowerCase() === "yes" && (
                <div className="text-xs text-white bg-yellow-500 px-2 py-1 rounded-md">
                  AAVRYAA'S BESTSELLER
                </div>
              )}
            </p>

            <h1 className="text-xl sm:text-2xl font-semibold">
              {product.name}
            </h1>

            {/* Quantity Selector */}
            <div className="flex items-center flex-wrap gap-3 sm:gap-5">
              {(() => {
                const step = product.scale.toLowerCase() === "meters" ? 0.5 : 1;
                const minVal = step;
                return (
                  <>
                    <div className="flex items-center border border-[#dae2e6] rounded-lg overflow-hidden">
                      <button
                        className="px-3 py-2 border-r border-[#dae2e6]"
                        onClick={() =>
                          setCount(count > minVal ? count - step : minVal)
                        }
                      >
                        -
                      </button>
                      <input
                        type="number"
                        value={count}
                        onChange={handleInputChange}
                        className="w-16 text-center outline-none"
                        step={step}
                        min={minVal}
                      />
                      <button
                        className="px-3 py-2 border-l border-[#dae2e6]"
                        onClick={() => setCount(count + step)}
                      >
                        +
                      </button>
                    </div>
                    <p className="text-sm">
                      {product.scale === "Meters"
                        ? "Quantity in meters"
                        : "Quantity in pieces"}
                    </p>
                  </>
                );
              })()}
            </div>

            <p className="text-sm">
              {product.quantity}{" "}
              {product.scale === "Meters" ? "meters" : "pieces"} in stock
            </p>

            {/* Price */}
            <div className="flex items-center flex-wrap gap-3">
              <p className="text-xl text-[#7a21db] font-bold">
                {currency}
                {newPrice.toFixed(2)}
                {product.old_price && (
                  <span className="text-sm text-red-500 ml-2">
                    {discountPercentage}% OFF
                  </span>
                )}
              </p>
              <p className="text-sm text-gray-700">
                {product.scale === "Meters" ? "/meter" : "/piece"}
              </p>
              <p className="text-sm text-gray-500">Inclusive of all taxes</p>
            </div>
            <p className="text-sm">
              M.R.P:{" "}
              <span className="line-through text-[#7a21db]">
                {currency}
                {product.old_price}
              </span>
            </p>

            {/* Size Selector */}
            {/* <div className="space-y-2">
              <h2 className="font-semibold">Select Size</h2>
              <div className="flex gap-3 flex-wrap">
                {["S", "M", "L", "XL", "XXL"].map((size) => (
                  <div
                    key={size}
                    onClick={() => handleSizeSelect(size)}
                    className={`px-4 py-2 border rounded-md cursor-pointer ${selectedSize === size ? "bg-[#a565e9] text-white" : "bg-white border-gray-300"}`}
                  >
                    {size}
                  </div>
                ))}
              </div>
            </div> */}

            {/* Cart Buttons */}
            <div className="flex flex-col sm:flex-row gap-4">
              {cartItems[product.id] > 0 ? (
                <button
                  className="w-full sm:w-1/2 py-3 bg-red-500 text-white rounded-md hover:bg-white hover:text-red-500 border transition"
                  onClick={() => deleteFromCart(product.id)}
                >
                  REMOVE FROM CART
                </button>
              ) : (
                <button
                  className="w-full sm:w-1/2 py-3 bg-[#a565e9] text-white rounded-md hover:bg-white hover:text-[#a565e9] border transition"
                  onClick={() => addToCart(product.id, count)}
                >
                  ADD TO CART
                </button>
              )}
              <button
                className={`w-full sm:w-1/2 py-3 rounded-md transition ${
                  product.status?.toLowerCase() === "in-stock"
                    ? "bg-[#a565e9] text-white hover:bg-white hover:text-[#a565e9]"
                    : "bg-gray-400 text-white cursor-not-allowed"
                }`}
                onClick={
                  product.status?.toLowerCase() === "in-stock"
                    ? handlePopupNow
                    : null
                }
                disabled={product.status?.toLowerCase() !== "in-stock"}
              >
                {product.status?.toLowerCase() === "in-stock"
                  ? "BUY NOW"
                  : "OUT OF STOCK"}
              </button>
            </div>

            {/* Quality Icons */}
            <div className="text-[#7656a0] text-lg font-bold mt-4">
              When you choose Aavryaa
            </div>
            <div className="flex items-center flex-wrap gap-4">
              <div className="flex items-center gap-2">
                <img
                  crossOrigin="anonymous"
                  src={quality_icon}
                  className="w-6"
                />
                <p className="text-sm">Exceptional Quality</p>
              </div>
              <div className="flex items-center gap-2">
                <img crossOrigin="anonymous" src={money_icon} className="w-6" />
                <p className="text-sm">Value For Money</p>
              </div>
              <div className="flex items-center gap-2">
                <img crossOrigin="anonymous" src={trust_icon} className="w-6" />
                <p className="text-sm">Trust Of Brand</p>
              </div>
            </div>

            {/* Tabs */}
            <div className="mt-6">
              <div className="flex gap-4 border-b border-[#976BD4] overflow-auto">
                {[
                  "Description",
                  "Fabric Estimator",
                  "Shipping",
                  "Washcare",
                ].map((tab) => (
                  <button
                    key={tab}
                    className={`pb-2 text-sm font-semibold uppercase text-[#7656a0] transition-all ${
                      activeTab === tab
                        ? "border-b-2 border-[#976BD4]"
                        : "hover:border-b"
                    }`}
                    onClick={() => setActiveTab(tab)}
                  >
                    {tab}
                  </button>
                ))}
              </div>

              <div className="mt-4 text-sm space-y-4">
                {activeTab === "Description" && (
                  <>
                    <h5 className="font-bold text-[#8c8399]">Description</h5>
                    <p>{product.description}</p>
                    <h5 className="font-bold text-[#8c8399]">Material</h5>
                    <p>{product.material}</p>
                    <h5 className="font-bold text-[#8c8399]">Width</h5>
                    <p>{product.size}</p>
                    <h5 className="font-bold text-[#8c8399]">Weight</h5>
                    <p>{product.weight}</p>
                    <h5 className="font-bold text-[#8c8399]">Quality</h5>
                    <p>{product.quality}</p>
                    <h5 className="font-bold text-[#8c8399]">Color</h5>
                    <p>{product.color}</p>
                    <h5 className="font-bold text-[#8c8399]">Disclaimer</h5>
                    <p>{product.disclaimer}</p>
                    <h5 className="font-bold text-[#8c8399]">Wash Care</h5>
                    <p>{product.washcare}</p>
                    <h6 className="font-bold text-[#8c8399]">Note</h6>
                    <p>{product.note}</p>
                    <h6 className="font-bold text-[#8c8399]">
                      Mktg. Or Mfg. By
                    </h6>
                    <p>Aavaryaa's FabHub</p>
                  </>
                )}

                {activeTab === "Fabric Estimator" && (
                  <>
                    <p>
                      Confused about how much fabric you need? Use our
                      estimator!
                    </p>
                    <button
                      onClick={() => setOpenModal(true)}
                      className="w-full sm:w-1/3 py-2 bg-[#976BD4] text-white rounded-md hover:bg-white hover:text-black border transition"
                    >
                      View Estimator
                    </button>

                    <EstimatorModal
                      isOpen={openModal}
                      onClose={() => setOpenModal(false)}
                      image1={EstimatorImage1} // 🔥 your image path here
                      image2={EstimatorImage2}
                    />
                  </>
                )}

                {activeTab === "Shipping" && (
                  <p>We ship across India and worldwide with care and speed.</p>
                )}

                {activeTab === "Washcare" && <p>{product.washcare}</p>}
              </div>
            </div>
          </div>
        </div>

        <About />

        <OrderPopup
          showPopup={showPopup}
          closePopup={closePopup}
          product={product}
          selectedSize={selectedSize}
          count={count}
          currency="₹"
          price={newPrice}
        />
      </div>

      <ToastContainer />
    </>
  );
};

export default Products;



